export default __webpack_public_path__ + "static/media/zombie-hand.b6c692b6.gif";